import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { AuthService } from './core/auth/auth.service';
import { CurrentUserService } from './core/auth/current-user.service';
import { createMsalInstance, MSAL_INSTANCE } from './core/auth/msal.config';
import { msalInterceptor } from './core/auth/msal.interceptor';
import { APP_CONFIG } from './core/config/app-config';
import { ConfigService } from './core/config/config.service';
import { ErrorHandlerService } from './core/error/error-handler.service';
import { correlationIdInterceptor } from './core/http/correlation-id.interceptor';
import { debugRoleInterceptor } from './core/http/debug-role.interceptor';
import { firstValueFrom } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([correlationIdInterceptor, msalInterceptor, debugRoleInterceptor])),
    { provide: APP_CONFIG, useValue: environment },
    { provide: MSAL_INSTANCE, useFactory: createMsalInstance, deps: [APP_CONFIG] },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    AuthService,
    provideAppInitializer(async () => {
      const config = inject(ConfigService);
      const auth = inject(AuthService);
      const currentUser = inject(CurrentUserService);
      await config.load();
      await auth.initialize();
      await firstValueFrom(currentUser.load());
    }),
  ],
};
